export default __webpack_public_path__ + "static/media/github_black.04be58c1.svg";